import axios from 'axios'
import router from '../router/router'
// var userType = window.sessionStorage.getItem('userType')
////http://zuul:7003/permissions
// axios 配置
//axios.defaults.timeout = 10000;
let baseURL = ''
if (process.env.NODE_ENV === 'development') {//这个是开发环境下
  baseURL = process.env.APP_BASE_APP_API
} else if (process.env.NODE_ENV === 'production') {//这个是生产环境下
  baseURL = process.env.APP_BASE_APP_API
}
axios.defaults.baseURL = baseURL
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.interceptors.request.use(
  config => {
    let token = window.sessionStorage.getItem("token")
    let userType = window.sessionStorage.getItem("userType")
    if (token && userType) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = token;
      config.headers.userType = userType;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });
axios.interceptors.response.use((res) => {
  if (res.data.errorCode == 196 || res.data.errorCode == 197) {
    window.sessionStorage.removeItem('token')
    let userType = window.sessionStorage.getItem("userType")
    if (userType == 0) {
      router.replace({ path: '/login' })
    }
    console.log(userType)
    if (userType == 1) {
      router.replace({ path: '/admin' })
    }



  }
  return res;
}, (error) => {
  return Promise.reject(error);
});

export function $post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function $get(url, param) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: param
    })
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function $post2(url, param) {
  return new Promise((resolve, reject) => {
    axios.post(url, param)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


// WEBPACK FOOTER //
// ./src/common/httpRequest.js